import React, {Component} from 'react';
import { connect } from 'react-redux';

import SerialsContainer from "./containers/serialscontainer.component";
import Filters from "../../../SHARED/components/filters/filters.component";
import Ads from "../ads/ads.component";
import HomeCards from "../homecards/homecards.component";
import Spinner from '../../../SHARED/components/spinner/spinner.component';

class Serials extends Component {

    componentDidMount() {
        window.gtag('event', 'page_view', {
            page_title: 'Cinemap',
            page_location: window.location.protocol + "//" + window.location.host + `/seriale`,
            page_path: `/seriale`,
          })
    }

    render() {
        return (
            <div className="serials">
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <div className="movies">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-3 sidebar-filters">
                                <Filters/>
                                <Ads
                                    id="div-gpt-ad-1662463314968-0"
                                    slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463314968-0'); googletag.pubads().refresh();});"
                                />
                            </div>


                            <div className="col-9">
                                <SerialsContainer/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="section-headline">
                                ARTICOLE RECOMANDATE
                            </div>

                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <HomeCards />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests
});
export default connect(mapStateToProps, {})(Serials);





// WEBPACK FOOTER //
// ./src/FO/components/serials/serials.component.js